import React, { useState } from "react";
import { Box, Container, Heading, Text, VStack, HStack, Icon, FormControl, FormLabel, Input, Button, SimpleGrid, Stat, StatLabel, StatNumber } from "@chakra-ui/react";
import { FaSolarPanel } from "react-icons/fa";
import { NavbarWithCallToAction } from "../../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { SEOHead } from "../../../components/SEOHead";

const PROPERTY_PRIMARY = "#0D7F6E";
const NAVY = "#141C49";

const PropertyToolsPropertySolarValue: React.FC = () => {
  const [value, setValue] = useState(550000);
  const [rent, setRent] = useState(500);
  const [solarCost, setSolarCost] = useState(8500);

  const valueIncrease = value * 0.04;
  const newValue = value + valueIncrease;
  const rentIncrease = rent * 0.07;
  const newRent = rent + rentIncrease;
  const roi = (((newRent - rent) * 52) / solarCost) * 100;

  return (
    <Box minH="100vh" bg="white">
      <SEOHead pagePath="/property/tools/property-solar-value" fallbackTitle="Property Solar Value Tool" fallbackDescription="Calculate value added by solar installations" />
      <NavbarWithCallToAction />
      <Box bgGradient={`linear(to-r, ${NAVY}, ${PROPERTY_PRIMARY})`} color="white" py={20}>
        <Container maxW="container.xl"><VStack spacing={6} textAlign="center"><Icon as={FaSolarPanel} boxSize={16} /><Heading size="3xl" fontWeight="black">Property + Solar Value Calculator</Heading><Text fontSize="xl">Calculate the value solar adds to your investment</Text></VStack></Container>
      </Box>
      <Container maxW="container.xl" py={16}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={12}>
          <VStack spacing={6} align="stretch">
            <Heading size="lg" color={NAVY}>Property Details</Heading>
            <FormControl><FormLabel>Current Property Value</FormLabel><Input type="number" value={value} onChange={(e) => setValue(Number(e.target.value))} /></FormControl>
            <FormControl><FormLabel>Current Weekly Rent</FormLabel><Input type="number" value={rent} onChange={(e) => setRent(Number(e.target.value))} /></FormControl>
            <FormControl><FormLabel>Solar System Cost</FormLabel><Input type="number" value={solarCost} onChange={(e) => setSolarCost(Number(e.target.value))} /></FormControl>
            <Button bg={PROPERTY_PRIMARY} color="white" _hover={{ bg: "#0a6459" }} size="lg" transition="all 0.2s">Calculate Value Add</Button>
          </VStack>
          <VStack spacing={6} align="stretch">
            <Heading size="lg" color={NAVY}>Solar Impact</Heading>
            <SimpleGrid columns={2} spacing={4}>
              <Stat bg="#EEF0F7" p={4} borderRadius="lg"><StatLabel fontSize="xs">Property Value</StatLabel><StatNumber fontSize="xl" color={NAVY}>${newValue.toLocaleString('en-US', {maximumFractionDigits: 0})}</StatNumber><Text fontSize="xs" color={PROPERTY_PRIMARY}>+${valueIncrease.toLocaleString('en-US', {maximumFractionDigits: 0})}</Text></Stat>
              <Stat bg="#E1F0EC" p={4} borderRadius="lg"><StatLabel fontSize="xs">Weekly Rent</StatLabel><StatNumber fontSize="xl" color={NAVY}>${newRent.toFixed(0)}</StatNumber><Text fontSize="xs" color={PROPERTY_PRIMARY}>+${rentIncrease.toFixed(0)}</Text></Stat>
            </SimpleGrid>
            <Stat bg="#E1F0EC" p={6} borderRadius="lg"><StatLabel>Annual ROI</StatLabel><StatNumber fontSize="3xl" color={PROPERTY_PRIMARY}>{roi.toFixed(1)}%</StatNumber></Stat>
            <Box bg="gray.50" p={6} borderRadius="lg">
              <Heading size="sm" mb={4} color={NAVY}>Summary</Heading>
              <VStack align="stretch" spacing={3}>
                <HStack justify="space-between"><Text fontSize="sm">Solar Investment</Text><Text fontWeight="bold">${solarCost.toLocaleString()}</Text></HStack>
                <HStack justify="space-between"><Text fontSize="sm">Value Increase</Text><Text fontWeight="bold" color={PROPERTY_PRIMARY}>${valueIncrease.toLocaleString('en-US', {maximumFractionDigits: 0})}</Text></HStack>
                <HStack justify="space-between"><Text fontSize="sm">Rent Increase (Annual)</Text><Text fontWeight="bold" color={PROPERTY_PRIMARY}>${(rentIncrease * 52).toFixed(0)}</Text></HStack>
              </VStack>
            </Box>
          </VStack>
        </SimpleGrid>
      </Container>
      <FooterWithFourColumns />
    </Box>
  );
};

export default PropertyToolsPropertySolarValue;
